import { render } from "./PagamentoSorteSucesso.vue?vue&type=template&id=b3ec5b2a"
import script from "./PagamentoSorteSucesso.vue?vue&type=script&lang=js"
export * from "./PagamentoSorteSucesso.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__